import { Dialog, AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FundingCostGrid from './FundingCostGrid';
import FieldNames from '../../../defaults/FieldNames.json';
import ColorConstants from '../../../defaults/ColorConstants';
import {useSelector} from "react-redux";

export default function CostsFundingPopover({
    open,
    onClose,
    editableFeature,
    setBaseFeatureAttributes,
    setEditableFeature,
    setLocationDepartmentValue,
    setLocationAgencyValue,
    setLocationRegionValue,
    setLocationUnitValue,
    featureUnsavedFields,
}) {
    const isApproved = useSelector((state) => state.displayState.isApproved);
    const mode = useSelector((state) => state.details.mode);

    return (
        <Dialog
            style={{ minWidth: 550 }}
            onClose={onClose}
            fullScreen
            open={open}
            className='dialog-modal'
        >
            <AppBar
                sx={{ position: 'relative' }}
                style={{ backgroundColor: ColorConstants.BlueAlien }}
            >
                <Toolbar>
                    <IconButton edge='start' color='inherit' onClick={onClose} aria-label='close'>
                        <CloseIcon style={{ fill: ColorConstants.WhiteAlien }} />
                    </IconButton>
                    <Typography
                        sx={{ ml: 2, flex: 1 }}
                        variant='h6'
                        component='div'
                        style={{ color: ColorConstants.WhiteAlien }}
                    >
                        {mode === FieldNames.modes.edit && !isApproved && <span>Manage Costs</span>}
                        {(mode !== FieldNames.modes.edit ||
                            (mode === FieldNames.modes.edit && isApproved)) && (
                            <span>View Costs</span>
                        )}
                    </Typography>
                </Toolbar>
            </AppBar>
            <FundingCostGrid
                editableFeature={editableFeature}
                setEditableFeature={setEditableFeature}
                setLocationDepartmentValue={setLocationDepartmentValue}
                setLocationAgencyValue={setLocationAgencyValue}
                setLocationRegionValue={setLocationRegionValue}
                setLocationUnitValue={setLocationUnitValue}
                featureUnsavedFields={featureUnsavedFields}
                setBaseFeatureAttributes={setBaseFeatureAttributes}
            />
        </Dialog>
    );
}
